import { render, staticRenderFns } from "./lbxy.vue?vue&type=template&id=c31df4d0&scoped=true&"
import script from "./lbxy.vue?vue&type=script&lang=js&"
export * from "./lbxy.vue?vue&type=script&lang=js&"
import style0 from "./lbxy.vue?vue&type=style&index=0&id=c31df4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31df4d0",
  null
  
)

export default component.exports